<script>
import { Bar } from "vue-chartjs";
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.plugins.unregister(ChartDataLabels);
Chart.plugins.register(ChartDataLabels);

export default {
  props : {
      labels:{
          type:Array,
          default: () => [],
      },
      data:{
          type:Array,
          default: () => [],
      },
      requestedPercentages: {
        type: Boolean,
        default: true,
      },
      useColors: {
        type: Boolean,
        default: true,
      },
      showLabelsOnTop: {
        type: Boolean,
        default: false
      },
  },
  computed:{
    ifDefaultTheme(){
      return  process.env.VUE_APP_THEME == 0
    },
    chartColor() {
      return this.ifDefaultTheme ? '#008FFB' : '#4f81bd'; 
    },  
    colorList() {
      return this.ifDefaultTheme ? [ '#f46a6a', '#008FFB', '#2ecc71'] : [ '#f46a6a', '#4f81bd', '#2ecc71'];
    },
    backgroundColors() {
      if (this.useColors) {
        return this.colorList;
      }
      return this.chartColor;
    }
  },
  extends: Bar,
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            barPercentage: 0.2,
            backgroundColor:  this.backgroundColors,
            borderColor:this.backgroundColors,
            borderWidth: 1,
            hoverBackgroundColor: this.backgroundColors,
            hoverBorderColor: this.backgroundColors,
            data: this.data,
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          datalabels: {
            display: true,  
            color: this.showLabelsOnTop ? '#000' : '#fff',
            anchor: this.showLabelsOnTop ? 'end' : 'center',
            align: this.showLabelsOnTop ? 'end' : 'center',
            formatter: (value) => {
              return this.requestedPercentages ? value != 0.0 ? value + ' %' : '' : value;
            }
          }
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem) => {
              return this.requestedPercentages
                ? tooltipItem.yLabel + ' %'
                : tooltipItem.yLabel;
            }
          }
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                color: "rgba(166, 176, 207, 0.1)"
              }
            }
          ],
          yAxes: [
            {
              gridLines: {
                color: "rgba(166, 176, 207, 0.1)",
              },
              ticks: {
                beginAtZero: true,
                suggestedMax: Math.max(...this.data) * 1.15, 
                callback: (val) => {
                  if (Number.isInteger(val)) {
                    return this.requestedPercentages ? val + ' %' : val;
                  }
                  return null;
                }
              }
            }
          ]
        },
        legend: {
          display: false
        }
      }
    );

  }
};
</script>